/* zuurii the brand — theme.js */
(function () {
  'use strict';

  /* ---- Scroll reveal ---- */
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('in'));
  }

  /* ---- Duplicate marquee content for seamless loop ---- */
  document.querySelectorAll('.marquee__track').forEach((track) => {
    track.innerHTML += track.innerHTML;
  });

  /* ---- Async add-to-cart (works against Shopify AJAX API) ---- */
  async function addToCart(id, qty) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 }),
    });
    if (!res.ok) throw new Error('add failed');
    return res.json();
  }

  async function refreshCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (_) {}
  }

  document.addEventListener('click', async (ev) => {
    const btn = ev.target.closest('[data-add]');
    if (!btn) return;
    ev.preventDefault();
    const id = btn.getAttribute('data-add');
    if (!id) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await addToCart(id, 1);
      await refreshCount();
      btn.textContent = 'Added ✓';
    } catch (_) {
      btn.textContent = 'Try again';
    } finally {
      setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1400);
    }
  });

  /* ---- PDP variant selection updates the buy button ---- */
  const pdp = document.querySelector('[data-product-json]');
  if (pdp) {
    let product;
    try { product = JSON.parse(pdp.textContent); } catch (_) { product = null; }
    const form = document.querySelector('[data-pdp-form]');
    if (product && form) {
      const priceEl = document.querySelector('[data-pdp-price]');
      const addBtn = form.querySelector('[data-pdp-add]');
      const formatMoney = (cents) =>
        new Intl.NumberFormat(document.documentElement.lang || 'de', {
          style: 'currency', currency: window.Shopify?.currency?.active || 'EUR',
        }).format(cents / 100);

      function selectedVariant() {
        const chosen = Array.from(form.querySelectorAll('[data-option]:checked'))
          .map((i) => i.value);
        return product.variants.find((v) =>
          v.options.every((opt, idx) => opt === chosen[idx])
        );
      }
      function sync() {
        const v = selectedVariant();
        if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
        addBtn.dataset.variantId = v.id;
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (priceEl) priceEl.textContent = formatMoney(v.price);
      }
      form.addEventListener('change', (e) => { if (e.target.matches('[data-option]')) sync(); });
      sync();

      addBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const id = addBtn.dataset.variantId;
        if (!id) return;
        addBtn.disabled = true;
        const t = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        try { await addToCart(id, 1); await refreshCount(); addBtn.textContent = 'Added ✓'; }
        catch (_) { addBtn.textContent = 'Try again'; }
        finally { setTimeout(() => { addBtn.textContent = t; addBtn.disabled = false; }, 1400); }
      });
    }
  }

  refreshCount();
})();
